// extracted by mini-css-extract-plugin
export default {"container":"styles_container__CRwvn","maxWidthContainer":"styles_maxWidthContainer__+0l4r","cards":"styles_cards__Jr3Ue","column":"styles_column__QFqo1","card":"styles_card__WTGlK"};